// extracted by mini-css-extract-plugin
module.exports = {"root":"_26ZgD","danger":"_3EwBk","success":"_2Xtgm","warning":"_17dPR","info":"_3_LSC","close":"_1xNSk","headline":"_15Os0","body":"_21Pct"};